import TimerContainer from './TimerContainer';

export default TimerContainer;
